import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { select_ui_settings } from 'console/redux/settings-actions';
import { useDevicesEvents } from 'console/dashboards/z3k/events/devices-events/useDevicesEvents';
import { DevicesEventsList } from 'console/dashboards/z3k/events/devices-events/devices-events-list';
export function DevicesEvents() {
    const { dashboard_settings } = useAppSelector(select_ui_settings);
    const device_ids = useMemo(() => {
        const device_ids = [];
        if (!dashboard_settings?.devices)
            return device_ids;
        dashboard_settings?.devices?.forEach((device) => {
            if (device.id) {
                device_ids.push(device.id);
            }
        });
        return device_ids;
    }, [dashboard_settings?.devices]);
    const { devicesEvents } = useDevicesEvents(device_ids);
    return _jsx(DevicesEventsList, { devices_events: devicesEvents });
}
